import React from 'react';
import ReactDOM from 'react-dom';

import './styles/global.scss';
import 'react-image-crop/dist/ReactCrop.css';
import IndexRouter from './routes';

ReactDOM.render(
  <React.StrictMode>
    <IndexRouter />
  </React.StrictMode>,
  document.getElementById('root'),
);
